import { notification } from "antd";
import Lottie from "react-lottie-player";
import { Images } from "../config";

const DefaultNotification = (message, type, placement) => {
  notification.open({
    message: (
      <div className="flex gap-0.1875em items-center">
        {type === "success" && (
          <Lottie
            loop
            animationData={Images.Done}
            play
            style={{ width: "3.125em" }} // 50px → 3.125em
          ></Lottie>
        )}
        <div className="text-[1.125em] font-semibold">{message ?? ""}</div>
      </div>
    ),
    placement: placement ?? "bottom",
    duration: 3,
    closable: false,
  });
};

export default DefaultNotification;
